import { useCallback } from 'react';
import { trackEvent } from 'helpers/analytics';

export const useUpsellTracking = () => {
  const trackPaywallShown = useCallback((featureName) => {
    trackEvent('upsell:paywall_shown', { featureName });
  }, []);

  const trackDemoClick = useCallback((featureName) => {
    trackEvent('upsell:demo_click', { featureName });
  }, []);

  return { trackPaywallShown, trackDemoClick };
};
